import { Component } from '@angular/core';
import { NavigationStart, Router } from "@angular/router";
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'tybu-web-app';
  constructor(
    private readonly router: Router,
    private readonly modalService: NgbModal,
    private readonly offcanvasService: NgbOffcanvas
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.modalService.dismissAll();
        if (this.offcanvasService.hasOpenOffcanvas()) {
          this.offcanvasService.dismiss();
        }
      }
    });
  }
}
